import ScrollButton from "../../components/ScrollButton";
import { useEffect } from "react";

// Edit this list to add / remove the open-source projects you maintain.
const projects = [
  {
    name: "Transparency Hub",
    role: "creator & maintainer",
    href: "https://asml.cyber.harvard.edu/transparency-hub/",
    description:
      "An open-source platform that aggregates and archives policy documents from hundreds of social media companies, helping researchers and the public track how platform governance evolves over time. Built at Harvard's Applied Social Media Lab.",
  },
];

const Projects = () => {
  useEffect(() => {
    document.title = "Code | Zoe-Alanah Robert";
  });
  return (
    <article className="about-main">
      <section>
        <h2 className="title-font pink-text">Code</h2>
        <p className="gray-text">Open-source software I build and maintain.</p>
        <ul className="project-list">
          {projects.map((project) => (
            <li key={project.name}>
              <a href={project.href} target="_blank" rel="noreferrer">
                {project.name}
              </a>
              {project.role ? <span className="project-role"> · {project.role}</span> : null}
              <span className="project-blurb gray-text">{project.description}</span>
            </li>
          ))}
        </ul>
      </section>
      <ScrollButton />
    </article>
  );
};

export default Projects;
